import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
    // zhCHT 繁体 zhCHS 简体
    locale: 'zhVietnamese',
    messages:{
        zhVietnamese: require('./lang/zhVietnamese'),
    }
})
export default i18n